export const TASK_PRIORITY_OPTIONS = [
  { value: 'low', label: 'Низкий' },
  { value: 'normal', label: 'Обычный' },
  { value: 'high', label: 'Высокий' },
  { value: 'critical', label: 'Критический' },
] as const

export type TaskPriority = (typeof TASK_PRIORITY_OPTIONS)[number]['value']

export interface PlannerTask {
  id: string
  title: string
  notes: string
  dueAt: string
  priority: TaskPriority
  completed: boolean
  reminderMinutes: number | null
  createdAt: string
  updatedAt: string
}

export const TASK_AUDIT_ACTION_TYPES = [
  'created',
  'rescheduled',
  'renamed',
  'notes_changed',
  'priority_changed',
  'reminder_changed',
  'completed',
  'reopened',
  'deleted',
] as const

export type TaskAuditActionType = (typeof TASK_AUDIT_ACTION_TYPES)[number]

export interface TaskAuditSnapshot {
  title: string
  notes: string
  dueAt: string
  priority: TaskPriority
  completed: boolean
  reminderMinutes: number | null
}

export interface TaskAuditAction {
  type: TaskAuditActionType
  before: string | null
  after: string | null
}

export interface TaskAuditEvent {
  id: string
  taskId: string
  occurredAt: string
  clientOccurredAt: string
  dueAt: string
  taskTitle: string
  before: TaskAuditSnapshot | null
  after: TaskAuditSnapshot | null
  actions: TaskAuditAction[]
  source: 'user'
}
